// src/utils/data/executives.js
// Using SAME folder as trustees

import presidentImg from '../../assets/images/president.jpg';
import thomasImg from '../../assets/images/thomas.jpeg';
import yemisiImg from '../../assets/images/yemisi.jpeg';
import onojaImg from '../../assets/images/onoja-prince.jpeg';
import godwinImg from '../../assets/images/godwin.jpeg';

export const executive = [
  {
    id: 1,
    name: 'Prof Stephen Obekpa Abah',
    role: 'President',
    image: presidentImg,
  },
  {
    id: 3,
    name: 'Dr Thomas Omachoko.',
    role: 'Secretary General',
    image: thomasImg,
  },
  {
    id: 4,
    name: 'Dr Yemisi Mary Anebi',
    role: 'Treasurerr',
    image: yemisiImg,
  },
  {
    id: 5,
    name: 'Dr Onoja Prince ',
    role: 'PRO',
    image: onojaImg,
  },
  {
    id: 6,
    name: 'Dr Godwin Ekoja.',
    role: 'Financial Secretrary',
    image: godwinImg,
  },
];